import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

// const ifNotAuthenticated = (_to, _from, next) => {
//   if (store.getters['auth/isAuthenticated']) {
//     next({ name: 'home' })
//   } else {
//     next()
//   }
// }

const ifAuthenticated = (_to, _from, next) => {
  if (store.getters['auth/isAuthenticated']) {
    next()
  } else {
    next({ name: 'admin_login' })
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/Privacy.vue'),
  },
  {
    path: '/contact_us',
    name: 'contact_us',
    component: () => import('@/views/ContactUs.vue'),
  },
  {
    path: '/performers',
    name: 'performers',
    component: () => import('@/views/Performers.vue'),
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/Categories.vue'),
  },
  {
    path: '/categories/:categoryID',
    name: 'category_details',
    component: () => import('@/views/CategoryDetails/CategoryDetails.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/songs',
    name: 'songs',
    component: () => import('@/views/Songs/Songs.vue'),
  },
  {
    path: '/users/create',
    name: 'create_user',
    component: () => import('@/views/CreateUser.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/admin',
    name: 'admin_login',
    component: () => import('@/views/AdminLogin.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
